module.exports = __webpack_public_path__ + "img/plug_x.ef9d84bf.svg";